import { fileAttachmentIdsInMessage } from '../../common-message-format/operators/fileAttachmentIdsInMessage';
import { lruMemoize } from '../../util/lruMemoize';
export const getFileAttachmentsForMessage = lruMemoize((message, fileAttachmentsMap) => {
  if (!message) {
    return [];
  }
  return fileAttachmentIdsInMessage(message).reduce((result, fileId) => {
    const fileMeta = fileAttachmentsMap[String(fileId)];
    if (fileMeta) {
      result.push(fileMeta);
    }
    return result;
  }, []);
});